import { useEffect, useState } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  type: "all",
  status: "accumulated",
  entered_date: "",
};

const HumidLogsFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const { _t } = useTranslator();
  const [filtersData, setFiltersData] = useState({
    type: filters.type || "all",
    status: filters.status || "accumulated",
    entered_date: filters.entered_date || "",
  });

  useEffect(() => {
    setFiltersData({
      type: filters.type || "all",
      status: filters.status || "accumulated",
      entered_date: filters.entered_date || "",
    });
  }, [filters.entered_date, filters.status, filters.type]);

  const handleChange = (e) => {
    setFiltersData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <SelectBox
        label={_t("type", "Type")}
        name="type"
        value={filtersData.type}
        options={[
          { value: "all", label: _t("all", "All") },
          { value: "cheeks", label: _t("type_cheeks", "Cheeks") },
          { value: "strips", label: _t("type_strips", "Strips") },
        ]}
        onChange={handleChange}
      />

      <SelectBox
        label={_t("status", "Status")}
        name="status"
        value={filtersData.status}
        options={[
          { value: "accumulated", label: _t("accumulated", "Accumulated") },
          { value: "processed", label: _t("processed", "Processed") },
          { value: "all", label: _t("all", "All") },
        ]}
        onChange={handleChange}
      />

      <InputWithLabel
        label={_t("entered_date", "Entered Date")}
        type="date"
        name="entered_date"
        value={filtersData.entered_date}
        onChange={handleChange}
      />

      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default HumidLogsFilter;